// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v7.35.1
// source: candle-data-depot.proto

/* eslint-disable */
import * as _m0 from "protobufjs/minimal";
import { Candle, Security } from "./candle-data-depot-common";
import { Exchange, exchangeFromJSON, exchangeToJSON, Expiry, Params, TimeBucket } from "./common";
import { OpenInterestChangeRequest, OpenInterestChangeResponse } from "./open-interest";
import { OrderBook_OrderBookQuote, Security as Security1, Segment, segmentFromJSON, segmentToJSON } from "./security";
import Long from "long";

export const protobufPackage = "com.tick2trade.api.candledatadepot";

export interface Securities {
  securities: Security[];
}

export interface Candles {
  candles: Candle[];
}

export interface SecurityCandles {
  security: Security | undefined;
  candle: Candle[];
}

export interface SecurityTimeBucketCandle {
  security: Security | undefined;
  timeBucket: TimeBucket | undefined;
  candle: Candle | undefined;
}

export interface SecurityTimeBucketCandles {
  securityTimeBucketCandles: SecurityTimeBucketCandle[];
}

export interface TimeBucketCandle {
  timeBucket: TimeBucket | undefined;
  candle: Candle | undefined;
}

export interface TimeBucketCandles {
  timeBucketCandles: TimeBucketCandle[];
}

export interface OIChangeCandle {
  startTimestamp: number;
  change: number;
}

export interface GetCandlesRequestV2 {
  security: Security | undefined;
  timeBucket: TimeBucket | undefined;
  referenceTime: number;
  forwardCandleCount: number;
  backwardCandleCount: number;
  dontGiveExtraCandles: boolean;
  accurateLastCandle: boolean;
  dontApplyCorporateActionAdjustments: boolean;
}

export interface GetCandlesBulkRequestV2 {
  requests: GetCandlesRequestV2[];
}

export interface GetCandlesBulkResponseV2 {
  responses: GetCandlesResponseV2[];
}

export interface GetCandlesResponseV2 {
  security: Security | undefined;
  timeBucket: TimeBucket | undefined;
  forwardCandles: Candle[];
  backwardCandles: Candle[];
  backwardCandleCount: number;
  backwardFirstCandleTime: string;
  backwardLastCandleTime: string;
  forwardCandleCount: number;
  forwardFirstCandleTime: string;
  forwardLastCandleTime: string;
  lastCandleStoreUpdateTime: number;
}

export interface CandleUpdateMessage {
  security: Security | undefined;
  candleUpdates: CandleUpdateMessage_CandleUpdate[];
}

export interface CandleUpdateMessage_CandleUpdate {
  timeBucket: TimeBucket | undefined;
  previousCandle: Candle | undefined;
  currentCandle: Candle | undefined;
}

export interface CandleUpdateMessages {
  segment: Segment;
  streamId: number;
  messages: CandleUpdateMessage[];
}

export interface TopBidAsks {
  topBidAsks: TopBidAsk[];
}

export interface TopBidAsk {
  security: Security | undefined;
  lastTradedTime: number;
  lastTradedPrice: number;
  volumeTradedToday: number;
  topBid: OrderBook_OrderBookQuote | undefined;
  topAsk: OrderBook_OrderBookQuote | undefined;
}

export interface GetSeriesRequest {
  seriesName: string;
  security: Security | undefined;
  timeBucket: TimeBucket | undefined;
  startTime: number;
  endTime: number;
  parameters: Params[];
}

export interface GetSeriesResponse {
  series: GetSeriesResponse_Series[];
}

export interface GetSeriesResponse_DataPoint {
  timestamp: number;
  label: string;
  values: number[];
}

export interface GetSeriesResponse_Series {
  seriesName: string;
  keys: string[];
  dataPoints: GetSeriesResponse_DataPoint[];
  firstDatapointTime: string;
  lastDatapointTime: string;
}

export interface GetCurrentOpenInterestRequest {
  security: Security | undefined;
  timeBucket: TimeBucket | undefined;
}

export interface GetCurrentOpenInterestResponse {
  security: Security | undefined;
  expiryOpenInterests: GetCurrentOpenInterestResponse_ExpiryOpenInterest[];
}

export interface GetCurrentOpenInterestResponse_ExpiryOpenInterest {
  expiry: Expiry | undefined;
  strikeOpenInterests: GetCurrentOpenInterestResponse_ExpiryOpenInterest_StrikeOpenInterest[];
}

export interface GetCurrentOpenInterestResponse_ExpiryOpenInterest_StrikeOpenInterest {
  strike: number;
  callOi: number;
  putOi: number;
  previousCallOi: number;
  previousPutOi: number;
}

export interface GetTradedSecuritiesRequest {
  start: number;
  end: number;
  segment: Segment;
  exchange: Exchange;
}

export interface GetTradedSecuritiesResponse {
  securities: Security1[];
}

function createBaseSecurities(): Securities {
  return { securities: [] };
}

export const Securities = {
  encode(message: Securities, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.securities) {
      Security.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Securities {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSecurities();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.securities.push(Security.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Securities {
    return {
      securities: globalThis.Array.isArray(object?.securities)
        ? object.securities.map((e: any) => Security.fromJSON(e))
        : [],
    };
  },

  toJSON(message: Securities): unknown {
    const obj: any = {};
    if (message.securities?.length) {
      obj.securities = message.securities.map((e) => Security.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Securities>, I>>(base?: I): Securities {
    return Securities.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Securities>, I>>(object: I): Securities {
    const message = createBaseSecurities();
    message.securities = object.securities?.map((e) => Security.fromPartial(e)) || [];
    return message;
  },
};

function createBaseCandles(): Candles {
  return { candles: [] };
}

export const Candles = {
  encode(message: Candles, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.candles) {
      Candle.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Candles {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCandles();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.candles.push(Candle.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Candles {
    return {
      candles: globalThis.Array.isArray(object?.candles) ? object.candles.map((e: any) => Candle.fromJSON(e)) : [],
    };
  },

  toJSON(message: Candles): unknown {
    const obj: any = {};
    if (message.candles?.length) {
      obj.candles = message.candles.map((e) => Candle.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Candles>, I>>(base?: I): Candles {
    return Candles.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Candles>, I>>(object: I): Candles {
    const message = createBaseCandles();
    message.candles = object.candles?.map((e) => Candle.fromPartial(e)) || [];
    return message;
  },
};

function createBaseSecurityCandles(): SecurityCandles {
  return { security: undefined, candle: [] };
}

export const SecurityCandles = {
  encode(message: SecurityCandles, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.security !== undefined) {
      Security.encode(message.security, writer.uint32(10).fork()).ldelim();
    }
    for (const v of message.candle) {
      Candle.encode(v!, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SecurityCandles {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSecurityCandles();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.security = Security.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.candle.push(Candle.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SecurityCandles {
    return {
      security: isSet(object.security) ? Security.fromJSON(object.security) : undefined,
      candle: globalThis.Array.isArray(object?.candle) ? object.candle.map((e: any) => Candle.fromJSON(e)) : [],
    };
  },

  toJSON(message: SecurityCandles): unknown {
    const obj: any = {};
    if (message.security !== undefined) {
      obj.security = Security.toJSON(message.security);
    }
    if (message.candle?.length) {
      obj.candle = message.candle.map((e) => Candle.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SecurityCandles>, I>>(base?: I): SecurityCandles {
    return SecurityCandles.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SecurityCandles>, I>>(object: I): SecurityCandles {
    const message = createBaseSecurityCandles();
    message.security = (object.security !== undefined && object.security !== null)
      ? Security.fromPartial(object.security)
      : undefined;
    message.candle = object.candle?.map((e) => Candle.fromPartial(e)) || [];
    return message;
  },
};

function createBaseSecurityTimeBucketCandle(): SecurityTimeBucketCandle {
  return { security: undefined, timeBucket: undefined, candle: undefined };
}

export const SecurityTimeBucketCandle = {
  encode(message: SecurityTimeBucketCandle, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.security !== undefined) {
      Security.encode(message.security, writer.uint32(10).fork()).ldelim();
    }
    if (message.timeBucket !== undefined) {
      TimeBucket.encode(message.timeBucket, writer.uint32(18).fork()).ldelim();
    }
    if (message.candle !== undefined) {
      Candle.encode(message.candle, writer.uint32(26).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SecurityTimeBucketCandle {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSecurityTimeBucketCandle();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.security = Security.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.timeBucket = TimeBucket.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.candle = Candle.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SecurityTimeBucketCandle {
    return {
      security: isSet(object.security) ? Security.fromJSON(object.security) : undefined,
      timeBucket: isSet(object.timeBucket) ? TimeBucket.fromJSON(object.timeBucket) : undefined,
      candle: isSet(object.candle) ? Candle.fromJSON(object.candle) : undefined,
    };
  },

  toJSON(message: SecurityTimeBucketCandle): unknown {
    const obj: any = {};
    if (message.security !== undefined) {
      obj.security = Security.toJSON(message.security);
    }
    if (message.timeBucket !== undefined) {
      obj.timeBucket = TimeBucket.toJSON(message.timeBucket);
    }
    if (message.candle !== undefined) {
      obj.candle = Candle.toJSON(message.candle);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SecurityTimeBucketCandle>, I>>(base?: I): SecurityTimeBucketCandle {
    return SecurityTimeBucketCandle.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SecurityTimeBucketCandle>, I>>(object: I): SecurityTimeBucketCandle {
    const message = createBaseSecurityTimeBucketCandle();
    message.security = (object.security !== undefined && object.security !== null)
      ? Security.fromPartial(object.security)
      : undefined;
    message.timeBucket = (object.timeBucket !== undefined && object.timeBucket !== null)
      ? TimeBucket.fromPartial(object.timeBucket)
      : undefined;
    message.candle = (object.candle !== undefined && object.candle !== null)
      ? Candle.fromPartial(object.candle)
      : undefined;
    return message;
  },
};

function createBaseSecurityTimeBucketCandles(): SecurityTimeBucketCandles {
  return { securityTimeBucketCandles: [] };
}

export const SecurityTimeBucketCandles = {
  encode(message: SecurityTimeBucketCandles, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.securityTimeBucketCandles) {
      SecurityTimeBucketCandle.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SecurityTimeBucketCandles {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSecurityTimeBucketCandles();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.securityTimeBucketCandles.push(SecurityTimeBucketCandle.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SecurityTimeBucketCandles {
    return {
      securityTimeBucketCandles: globalThis.Array.isArray(object?.securityTimeBucketCandles)
        ? object.securityTimeBucketCandles.map((e: any) => SecurityTimeBucketCandle.fromJSON(e))
        : [],
    };
  },

  toJSON(message: SecurityTimeBucketCandles): unknown {
    const obj: any = {};
    if (message.securityTimeBucketCandles?.length) {
      obj.securityTimeBucketCandles = message.securityTimeBucketCandles.map((e) => SecurityTimeBucketCandle.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SecurityTimeBucketCandles>, I>>(base?: I): SecurityTimeBucketCandles {
    return SecurityTimeBucketCandles.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SecurityTimeBucketCandles>, I>>(object: I): SecurityTimeBucketCandles {
    const message = createBaseSecurityTimeBucketCandles();
    message.securityTimeBucketCandles =
      object.securityTimeBucketCandles?.map((e) => SecurityTimeBucketCandle.fromPartial(e)) || [];
    return message;
  },
};

function createBaseTimeBucketCandle(): TimeBucketCandle {
  return { timeBucket: undefined, candle: undefined };
}

export const TimeBucketCandle = {
  encode(message: TimeBucketCandle, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.timeBucket !== undefined) {
      TimeBucket.encode(message.timeBucket, writer.uint32(10).fork()).ldelim();
    }
    if (message.candle !== undefined) {
      Candle.encode(message.candle, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TimeBucketCandle {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTimeBucketCandle();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.timeBucket = TimeBucket.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.candle = Candle.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TimeBucketCandle {
    return {
      timeBucket: isSet(object.timeBucket) ? TimeBucket.fromJSON(object.timeBucket) : undefined,
      candle: isSet(object.candle) ? Candle.fromJSON(object.candle) : undefined,
    };
  },

  toJSON(message: TimeBucketCandle): unknown {
    const obj: any = {};
    if (message.timeBucket !== undefined) {
      obj.timeBucket = TimeBucket.toJSON(message.timeBucket);
    }
    if (message.candle !== undefined) {
      obj.candle = Candle.toJSON(message.candle);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TimeBucketCandle>, I>>(base?: I): TimeBucketCandle {
    return TimeBucketCandle.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TimeBucketCandle>, I>>(object: I): TimeBucketCandle {
    const message = createBaseTimeBucketCandle();
    message.timeBucket = (object.timeBucket !== undefined && object.timeBucket !== null)
      ? TimeBucket.fromPartial(object.timeBucket)
      : undefined;
    message.candle = (object.candle !== undefined && object.candle !== null)
      ? Candle.fromPartial(object.candle)
      : undefined;
    return message;
  },
};

function createBaseTimeBucketCandles(): TimeBucketCandles {
  return { timeBucketCandles: [] };
}

export const TimeBucketCandles = {
  encode(message: TimeBucketCandles, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.timeBucketCandles) {
      TimeBucketCandle.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TimeBucketCandles {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTimeBucketCandles();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.timeBucketCandles.push(TimeBucketCandle.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TimeBucketCandles {
    return {
      timeBucketCandles: globalThis.Array.isArray(object?.timeBucketCandles)
        ? object.timeBucketCandles.map((e: any) => TimeBucketCandle.fromJSON(e))
        : [],
    };
  },

  toJSON(message: TimeBucketCandles): unknown {
    const obj: any = {};
    if (message.timeBucketCandles?.length) {
      obj.timeBucketCandles = message.timeBucketCandles.map((e) => TimeBucketCandle.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TimeBucketCandles>, I>>(base?: I): TimeBucketCandles {
    return TimeBucketCandles.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TimeBucketCandles>, I>>(object: I): TimeBucketCandles {
    const message = createBaseTimeBucketCandles();
    message.timeBucketCandles = object.timeBucketCandles?.map((e) => TimeBucketCandle.fromPartial(e)) || [];
    return message;
  },
};

function createBaseOIChangeCandle(): OIChangeCandle {
  return { startTimestamp: 0, change: 0 };
}

export const OIChangeCandle = {
  encode(message: OIChangeCandle, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.startTimestamp !== 0) {
      writer.uint32(8).int64(message.startTimestamp);
    }
    if (message.change !== 0) {
      writer.uint32(16).int64(message.change);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): OIChangeCandle {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOIChangeCandle();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.startTimestamp = longToNumber(reader.int64() as Long);
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.change = longToNumber(reader.int64() as Long);
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OIChangeCandle {
    return {
      startTimestamp: isSet(object.startTimestamp) ? globalThis.Number(object.startTimestamp) : 0,
      change: isSet(object.change) ? globalThis.Number(object.change) : 0,
    };
  },

  toJSON(message: OIChangeCandle): unknown {
    const obj: any = {};
    if (message.startTimestamp !== 0) {
      obj.startTimestamp = Math.round(message.startTimestamp);
    }
    if (message.change !== 0) {
      obj.change = Math.round(message.change);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OIChangeCandle>, I>>(base?: I): OIChangeCandle {
    return OIChangeCandle.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OIChangeCandle>, I>>(object: I): OIChangeCandle {
    const message = createBaseOIChangeCandle();
    message.startTimestamp = object.startTimestamp ?? 0;
    message.change = object.change ?? 0;
    return message;
  },
};

function createBaseGetCandlesRequestV2(): GetCandlesRequestV2 {
  return {
    security: undefined,
    timeBucket: undefined,
    referenceTime: 0,
    forwardCandleCount: 0,
    backwardCandleCount: 0,
    dontGiveExtraCandles: false,
    accurateLastCandle: false,
    dontApplyCorporateActionAdjustments: false,
  };
}

export const GetCandlesRequestV2 = {
  encode(message: GetCandlesRequestV2, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.security !== undefined) {
      Security.encode(message.security, writer.uint32(18).fork()).ldelim();
    }
    if (message.timeBucket !== undefined) {
      TimeBucket.encode(message.timeBucket, writer.uint32(34).fork()).ldelim();
    }
    if (message.referenceTime !== 0) {
      writer.uint32(48).int64(message.referenceTime);
    }
    if (message.forwardCandleCount !== 0) {
      writer.uint32(64).int32(message.forwardCandleCount);
    }
    if (message.backwardCandleCount !== 0) {
      writer.uint32(80).int32(message.backwardCandleCount);
    }
    if (message.dontGiveExtraCandles !== false) {
      writer.uint32(96).bool(message.dontGiveExtraCandles);
    }
    if (message.accurateLastCandle !== false) {
      writer.uint32(120).bool(message.accurateLastCandle);
    }
    if (message.dontApplyCorporateActionAdjustments !== false) {
      writer.uint32(128).bool(message.dontApplyCorporateActionAdjustments);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetCandlesRequestV2 {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetCandlesRequestV2();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2:
          if (tag !== 18) {
            break;
          }

          message.security = Security.decode(reader, reader.uint32());
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.timeBucket = TimeBucket.decode(reader, reader.uint32());
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.referenceTime = longToNumber(reader.int64() as Long);
          continue;
        case 8:
          if (tag !== 64) {
            break;
          }

          message.forwardCandleCount = reader.int32();
          continue;
        case 10:
          if (tag !== 80) {
            break;
          }

          message.backwardCandleCount = reader.int32();
          continue;
        case 12:
          if (tag !== 96) {
            break;
          }

          message.dontGiveExtraCandles = reader.bool();
          continue;
        case 15:
          if (tag !== 120) {
            break;
          }

          message.accurateLastCandle = reader.bool();
          continue;
        case 16:
          if (tag !== 128) {
            break;
          }

          message.dontApplyCorporateActionAdjustments = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetCandlesRequestV2 {
    return {
      security: isSet(object.security) ? Security.fromJSON(object.security) : undefined,
      timeBucket: isSet(object.timeBucket) ? TimeBucket.fromJSON(object.timeBucket) : undefined,
      referenceTime: isSet(object.referenceTime) ? globalThis.Number(object.referenceTime) : 0,
      forwardCandleCount: isSet(object.forwardCandleCount) ? globalThis.Number(object.forwardCandleCount) : 0,
      backwardCandleCount: isSet(object.backwardCandleCount) ? globalThis.Number(object.backwardCandleCount) : 0,
      dontGiveExtraCandles: isSet(object.dontGiveExtraCandles)
        ? globalThis.Boolean(object.dontGiveExtraCandles)
        : false,
      accurateLastCandle: isSet(object.accurateLastCandle) ? globalThis.Boolean(object.accurateLastCandle) : false,
      dontApplyCorporateActionAdjustments: isSet(object.dontApplyCorporateActionAdjustments)
        ? globalThis.Boolean(object.dontApplyCorporateActionAdjustments)
        : false,
    };
  },

  toJSON(message: GetCandlesRequestV2): unknown {
    const obj: any = {};
    if (message.security !== undefined) {
      obj.security = Security.toJSON(message.security);
    }
    if (message.timeBucket !== undefined) {
      obj.timeBucket = TimeBucket.toJSON(message.timeBucket);
    }
    if (message.referenceTime !== 0) {
      obj.referenceTime = Math.round(message.referenceTime);
    }
    if (message.forwardCandleCount !== 0) {
      obj.forwardCandleCount = Math.round(message.forwardCandleCount);
    }
    if (message.backwardCandleCount !== 0) {
      obj.backwardCandleCount = Math.round(message.backwardCandleCount);
    }
    if (message.dontGiveExtraCandles !== false) {
      obj.dontGiveExtraCandles = message.dontGiveExtraCandles;
    }
    if (message.accurateLastCandle !== false) {
      obj.accurateLastCandle = message.accurateLastCandle;
    }
    if (message.dontApplyCorporateActionAdjustments !== false) {
      obj.dontApplyCorporateActionAdjustments = message.dontApplyCorporateActionAdjustments;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetCandlesRequestV2>, I>>(base?: I): GetCandlesRequestV2 {
    return GetCandlesRequestV2.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetCandlesRequestV2>, I>>(object: I): GetCandlesRequestV2 {
    const message = createBaseGetCandlesRequestV2();
    message.security = (object.security !== undefined && object.security !== null)
      ? Security.fromPartial(object.security)
      : undefined;
    message.timeBucket = (object.timeBucket !== undefined && object.timeBucket !== null)
      ? TimeBucket.fromPartial(object.timeBucket)
      : undefined;
    message.referenceTime = object.referenceTime ?? 0;
    message.forwardCandleCount = object.forwardCandleCount ?? 0;
    message.backwardCandleCount = object.backwardCandleCount ?? 0;
    message.dontGiveExtraCandles = object.dontGiveExtraCandles ?? false;
    message.accurateLastCandle = object.accurateLastCandle ?? false;
    message.dontApplyCorporateActionAdjustments = object.dontApplyCorporateActionAdjustments ?? false;
    return message;
  },
};

function createBaseGetCandlesBulkRequestV2(): GetCandlesBulkRequestV2 {
  return { requests: [] };
}

export const GetCandlesBulkRequestV2 = {
  encode(message: GetCandlesBulkRequestV2, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.requests) {
      GetCandlesRequestV2.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetCandlesBulkRequestV2 {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetCandlesBulkRequestV2();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.requests.push(GetCandlesRequestV2.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetCandlesBulkRequestV2 {
    return {
      requests: globalThis.Array.isArray(object?.requests)
        ? object.requests.map((e: any) => GetCandlesRequestV2.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GetCandlesBulkRequestV2): unknown {
    const obj: any = {};
    if (message.requests?.length) {
      obj.requests = message.requests.map((e) => GetCandlesRequestV2.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetCandlesBulkRequestV2>, I>>(base?: I): GetCandlesBulkRequestV2 {
    return GetCandlesBulkRequestV2.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetCandlesBulkRequestV2>, I>>(object: I): GetCandlesBulkRequestV2 {
    const message = createBaseGetCandlesBulkRequestV2();
    message.requests = object.requests?.map((e) => GetCandlesRequestV2.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetCandlesBulkResponseV2(): GetCandlesBulkResponseV2 {
  return { responses: [] };
}

export const GetCandlesBulkResponseV2 = {
  encode(message: GetCandlesBulkResponseV2, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.responses) {
      GetCandlesResponseV2.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetCandlesBulkResponseV2 {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetCandlesBulkResponseV2();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.responses.push(GetCandlesResponseV2.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetCandlesBulkResponseV2 {
    return {
      responses: globalThis.Array.isArray(object?.responses)
        ? object.responses.map((e: any) => GetCandlesResponseV2.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GetCandlesBulkResponseV2): unknown {
    const obj: any = {};
    if (message.responses?.length) {
      obj.responses = message.responses.map((e) => GetCandlesResponseV2.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetCandlesBulkResponseV2>, I>>(base?: I): GetCandlesBulkResponseV2 {
    return GetCandlesBulkResponseV2.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetCandlesBulkResponseV2>, I>>(object: I): GetCandlesBulkResponseV2 {
    const message = createBaseGetCandlesBulkResponseV2();
    message.responses = object.responses?.map((e) => GetCandlesResponseV2.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetCandlesResponseV2(): GetCandlesResponseV2 {
  return {
    security: undefined,
    timeBucket: undefined,
    forwardCandles: [],
    backwardCandles: [],
    backwardCandleCount: 0,
    backwardFirstCandleTime: "",
    backwardLastCandleTime: "",
    forwardCandleCount: 0,
    forwardFirstCandleTime: "",
    forwardLastCandleTime: "",
    lastCandleStoreUpdateTime: 0,
  };
}

export const GetCandlesResponseV2 = {
  encode(message: GetCandlesResponseV2, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.security !== undefined) {
      Security.encode(message.security, writer.uint32(10).fork()).ldelim();
    }
    if (message.timeBucket !== undefined) {
      TimeBucket.encode(message.timeBucket, writer.uint32(18).fork()).ldelim();
    }
    for (const v of message.forwardCandles) {
      Candle.encode(v!, writer.uint32(34).fork()).ldelim();
    }
    for (const v of message.backwardCandles) {
      Candle.encode(v!, writer.uint32(50).fork()).ldelim();
    }
    if (message.backwardCandleCount !== 0) {
      writer.uint32(64).int32(message.backwardCandleCount);
    }
    if (message.backwardFirstCandleTime !== "") {
      writer.uint32(82).string(message.backwardFirstCandleTime);
    }
    if (message.backwardLastCandleTime !== "") {
      writer.uint32(98).string(message.backwardLastCandleTime);
    }
    if (message.forwardCandleCount !== 0) {
      writer.uint32(112).int32(message.forwardCandleCount);
    }
    if (message.forwardFirstCandleTime !== "") {
      writer.uint32(130).string(message.forwardFirstCandleTime);
    }
    if (message.forwardLastCandleTime !== "") {
      writer.uint32(146).string(message.forwardLastCandleTime);
    }
    if (message.lastCandleStoreUpdateTime !== 0) {
      writer.uint32(56).int64(message.lastCandleStoreUpdateTime);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetCandlesResponseV2 {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetCandlesResponseV2();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.security = Security.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.timeBucket = TimeBucket.decode(reader, reader.uint32());
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.forwardCandles.push(Candle.decode(reader, reader.uint32()));
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.backwardCandles.push(Candle.decode(reader, reader.uint32()));
          continue;
        case 8:
          if (tag !== 64) {
            break;
          }

          message.backwardCandleCount = reader.int32();
          continue;
        case 10:
          if (tag !== 82) {
            break;
          }

          message.backwardFirstCandleTime = reader.string();
          continue;
        case 12:
          if (tag !== 98) {
            break;
          }

          message.backwardLastCandleTime = reader.string();
          continue;
        case 14:
          if (tag !== 112) {
            break;
          }

          message.forwardCandleCount = reader.int32();
          continue;
        case 16:
          if (tag !== 130) {
            break;
          }

          message.forwardFirstCandleTime = reader.string();
          continue;
        case 18:
          if (tag !== 146) {
            break;
          }

          message.forwardLastCandleTime = reader.string();
          continue;
        case 7:
          if (tag !== 56) {
            break;
          }

          message.lastCandleStoreUpdateTime = longToNumber(reader.int64() as Long);
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetCandlesResponseV2 {
    return {
      security: isSet(object.security) ? Security.fromJSON(object.security) : undefined,
      timeBucket: isSet(object.timeBucket) ? TimeBucket.fromJSON(object.timeBucket) : undefined,
      forwardCandles: globalThis.Array.isArray(object?.forwardCandles)
        ? object.forwardCandles.map((e: any) => Candle.fromJSON(e))
        : [],
      backwardCandles: globalThis.Array.isArray(object?.backwardCandles)
        ? object.backwardCandles.map((e: any) => Candle.fromJSON(e))
        : [],
      backwardCandleCount: isSet(object.backwardCandleCount) ? globalThis.Number(object.backwardCandleCount) : 0,
      backwardFirstCandleTime: isSet(object.backwardFirstCandleTime)
        ? globalThis.String(object.backwardFirstCandleTime)
        : "",
      backwardLastCandleTime: isSet(object.backwardLastCandleTime)
        ? globalThis.String(object.backwardLastCandleTime)
        : "",
      forwardCandleCount: isSet(object.forwardCandleCount) ? globalThis.Number(object.forwardCandleCount) : 0,
      forwardFirstCandleTime: isSet(object.forwardFirstCandleTime)
        ? globalThis.String(object.forwardFirstCandleTime)
        : "",
      forwardLastCandleTime: isSet(object.forwardLastCandleTime) ? globalThis.String(object.forwardLastCandleTime) : "",
      lastCandleStoreUpdateTime: isSet(object.lastCandleStoreUpdateTime)
        ? globalThis.Number(object.lastCandleStoreUpdateTime)
        : 0,
    };
  },

  toJSON(message: GetCandlesResponseV2): unknown {
    const obj: any = {};
    if (message.security !== undefined) {
      obj.security = Security.toJSON(message.security);
    }
    if (message.timeBucket !== undefined) {
      obj.timeBucket = TimeBucket.toJSON(message.timeBucket);
    }
    if (message.forwardCandles?.length) {
      obj.forwardCandles = message.forwardCandles.map((e) => Candle.toJSON(e));
    }
    if (message.backwardCandles?.length) {
      obj.backwardCandles = message.backwardCandles.map((e) => Candle.toJSON(e));
    }
    if (message.backwardCandleCount !== 0) {
      obj.backwardCandleCount = Math.round(message.backwardCandleCount);
    }
    if (message.backwardFirstCandleTime !== "") {
      obj.backwardFirstCandleTime = message.backwardFirstCandleTime;
    }
    if (message.backwardLastCandleTime !== "") {
      obj.backwardLastCandleTime = message.backwardLastCandleTime;
    }
    if (message.forwardCandleCount !== 0) {
      obj.forwardCandleCount = Math.round(message.forwardCandleCount);
    }
    if (message.forwardFirstCandleTime !== "") {
      obj.forwardFirstCandleTime = message.forwardFirstCandleTime;
    }
    if (message.forwardLastCandleTime !== "") {
      obj.forwardLastCandleTime = message.forwardLastCandleTime;
    }
    if (message.lastCandleStoreUpdateTime !== 0) {
      obj.lastCandleStoreUpdateTime = Math.round(message.lastCandleStoreUpdateTime);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetCandlesResponseV2>, I>>(base?: I): GetCandlesResponseV2 {
    return GetCandlesResponseV2.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetCandlesResponseV2>, I>>(object: I): GetCandlesResponseV2 {
    const message = createBaseGetCandlesResponseV2();
    message.security = (object.security !== undefined && object.security !== null)
      ? Security.fromPartial(object.security)
      : undefined;
    message.timeBucket = (object.timeBucket !== undefined && object.timeBucket !== null)
      ? TimeBucket.fromPartial(object.timeBucket)
      : undefined;
    message.forwardCandles = object.forwardCandles?.map((e) => Candle.fromPartial(e)) || [];
    message.backwardCandles = object.backwardCandles?.map((e) => Candle.fromPartial(e)) || [];
    message.backwardCandleCount = object.backwardCandleCount ?? 0;
    message.backwardFirstCandleTime = object.backwardFirstCandleTime ?? "";
    message.backwardLastCandleTime = object.backwardLastCandleTime ?? "";
    message.forwardCandleCount = object.forwardCandleCount ?? 0;
    message.forwardFirstCandleTime = object.forwardFirstCandleTime ?? "";
    message.forwardLastCandleTime = object.forwardLastCandleTime ?? "";
    message.lastCandleStoreUpdateTime = object.lastCandleStoreUpdateTime ?? 0;
    return message;
  },
};

function createBaseCandleUpdateMessage(): CandleUpdateMessage {
  return { security: undefined, candleUpdates: [] };
}

export const CandleUpdateMessage = {
  encode(message: CandleUpdateMessage, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.security !== undefined) {
      Security.encode(message.security, writer.uint32(10).fork()).ldelim();
    }
    for (const v of message.candleUpdates) {
      CandleUpdateMessage_CandleUpdate.encode(v!, writer.uint32(26).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): CandleUpdateMessage {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCandleUpdateMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.security = Security.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.candleUpdates.push(CandleUpdateMessage_CandleUpdate.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CandleUpdateMessage {
    return {
      security: isSet(object.security) ? Security.fromJSON(object.security) : undefined,
      candleUpdates: globalThis.Array.isArray(object?.candleUpdates)
        ? object.candleUpdates.map((e: any) => CandleUpdateMessage_CandleUpdate.fromJSON(e))
        : [],
    };
  },

  toJSON(message: CandleUpdateMessage): unknown {
    const obj: any = {};
    if (message.security !== undefined) {
      obj.security = Security.toJSON(message.security);
    }
    if (message.candleUpdates?.length) {
      obj.candleUpdates = message.candleUpdates.map((e) => CandleUpdateMessage_CandleUpdate.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CandleUpdateMessage>, I>>(base?: I): CandleUpdateMessage {
    return CandleUpdateMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CandleUpdateMessage>, I>>(object: I): CandleUpdateMessage {
    const message = createBaseCandleUpdateMessage();
    message.security = (object.security !== undefined && object.security !== null)
      ? Security.fromPartial(object.security)
      : undefined;
    message.candleUpdates = object.candleUpdates?.map((e) => CandleUpdateMessage_CandleUpdate.fromPartial(e)) || [];
    return message;
  },
};

function createBaseCandleUpdateMessage_CandleUpdate(): CandleUpdateMessage_CandleUpdate {
  return { timeBucket: undefined, previousCandle: undefined, currentCandle: undefined };
}

export const CandleUpdateMessage_CandleUpdate = {
  encode(message: CandleUpdateMessage_CandleUpdate, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.timeBucket !== undefined) {
      TimeBucket.encode(message.timeBucket, writer.uint32(34).fork()).ldelim();
    }
    if (message.previousCandle !== undefined) {
      Candle.encode(message.previousCandle, writer.uint32(50).fork()).ldelim();
    }
    if (message.currentCandle !== undefined) {
      Candle.encode(message.currentCandle, writer.uint32(66).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): CandleUpdateMessage_CandleUpdate {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCandleUpdateMessage_CandleUpdate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 4:
          if (tag !== 34) {
            break;
          }

          message.timeBucket = TimeBucket.decode(reader, reader.uint32());
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.previousCandle = Candle.decode(reader, reader.uint32());
          continue;
        case 8:
          if (tag !== 66) {
            break;
          }

          message.currentCandle = Candle.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CandleUpdateMessage_CandleUpdate {
    return {
      timeBucket: isSet(object.timeBucket) ? TimeBucket.fromJSON(object.timeBucket) : undefined,
      previousCandle: isSet(object.previousCandle) ? Candle.fromJSON(object.previousCandle) : undefined,
      currentCandle: isSet(object.currentCandle) ? Candle.fromJSON(object.currentCandle) : undefined,
    };
  },

  toJSON(message: CandleUpdateMessage_CandleUpdate): unknown {
    const obj: any = {};
    if (message.timeBucket !== undefined) {
      obj.timeBucket = TimeBucket.toJSON(message.timeBucket);
    }
    if (message.previousCandle !== undefined) {
      obj.previousCandle = Candle.toJSON(message.previousCandle);
    }
    if (message.currentCandle !== undefined) {
      obj.currentCandle = Candle.toJSON(message.currentCandle);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CandleUpdateMessage_CandleUpdate>, I>>(
    base?: I,
  ): CandleUpdateMessage_CandleUpdate {
    return CandleUpdateMessage_CandleUpdate.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CandleUpdateMessage_CandleUpdate>, I>>(
    object: I,
  ): CandleUpdateMessage_CandleUpdate {
    const message = createBaseCandleUpdateMessage_CandleUpdate();
    message.timeBucket = (object.timeBucket !== undefined && object.timeBucket !== null)
      ? TimeBucket.fromPartial(object.timeBucket)
      : undefined;
    message.previousCandle = (object.previousCandle !== undefined && object.previousCandle !== null)
      ? Candle.fromPartial(object.previousCandle)
      : undefined;
    message.currentCandle = (object.currentCandle !== undefined && object.currentCandle !== null)
      ? Candle.fromPartial(object.currentCandle)
      : undefined;
    return message;
  },
};

function createBaseCandleUpdateMessages(): CandleUpdateMessages {
  return { segment: 0, streamId: 0, messages: [] };
}

export const CandleUpdateMessages = {
  encode(message: CandleUpdateMessages, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.segment !== 0) {
      writer.uint32(8).int32(message.segment);
    }
    if (message.streamId !== 0) {
      writer.uint32(16).int32(message.streamId);
    }
    for (const v of message.messages) {
      CandleUpdateMessage.encode(v!, writer.uint32(26).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): CandleUpdateMessages {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCandleUpdateMessages();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.segment = reader.int32() as any;
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.streamId = reader.int32();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.messages.push(CandleUpdateMessage.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CandleUpdateMessages {
    return {
      segment: isSet(object.segment) ? segmentFromJSON(object.segment) : 0,
      streamId: isSet(object.streamId) ? globalThis.Number(object.streamId) : 0,
      messages: globalThis.Array.isArray(object?.messages)
        ? object.messages.map((e: any) => CandleUpdateMessage.fromJSON(e))
        : [],
    };
  },

  toJSON(message: CandleUpdateMessages): unknown {
    const obj: any = {};
    if (message.segment !== 0) {
      obj.segment = segmentToJSON(message.segment);
    }
    if (message.streamId !== 0) {
      obj.streamId = Math.round(message.streamId);
    }
    if (message.messages?.length) {
      obj.messages = message.messages.map((e) => CandleUpdateMessage.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CandleUpdateMessages>, I>>(base?: I): CandleUpdateMessages {
    return CandleUpdateMessages.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CandleUpdateMessages>, I>>(object: I): CandleUpdateMessages {
    const message = createBaseCandleUpdateMessages();
    message.segment = object.segment ?? 0;
    message.streamId = object.streamId ?? 0;
    message.messages = object.messages?.map((e) => CandleUpdateMessage.fromPartial(e)) || [];
    return message;
  },
};

function createBaseTopBidAsks(): TopBidAsks {
  return { topBidAsks: [] };
}

export const TopBidAsks = {
  encode(message: TopBidAsks, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.topBidAsks) {
      TopBidAsk.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TopBidAsks {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTopBidAsks();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.topBidAsks.push(TopBidAsk.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TopBidAsks {
    return {
      topBidAsks: globalThis.Array.isArray(object?.topBidAsks)
        ? object.topBidAsks.map((e: any) => TopBidAsk.fromJSON(e))
        : [],
    };
  },

  toJSON(message: TopBidAsks): unknown {
    const obj: any = {};
    if (message.topBidAsks?.length) {
      obj.topBidAsks = message.topBidAsks.map((e) => TopBidAsk.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TopBidAsks>, I>>(base?: I): TopBidAsks {
    return TopBidAsks.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TopBidAsks>, I>>(object: I): TopBidAsks {
    const message = createBaseTopBidAsks();
    message.topBidAsks = object.topBidAsks?.map((e) => TopBidAsk.fromPartial(e)) || [];
    return message;
  },
};

function createBaseTopBidAsk(): TopBidAsk {
  return {
    security: undefined,
    lastTradedTime: 0,
    lastTradedPrice: 0,
    volumeTradedToday: 0,
    topBid: undefined,
    topAsk: undefined,
  };
}

export const TopBidAsk = {
  encode(message: TopBidAsk, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.security !== undefined) {
      Security.encode(message.security, writer.uint32(10).fork()).ldelim();
    }
    if (message.lastTradedTime !== 0) {
      writer.uint32(32).int64(message.lastTradedTime);
    }
    if (message.lastTradedPrice !== 0) {
      writer.uint32(40).int32(message.lastTradedPrice);
    }
    if (message.volumeTradedToday !== 0) {
      writer.uint32(56).int32(message.volumeTradedToday);
    }
    if (message.topBid !== undefined) {
      OrderBook_OrderBookQuote.encode(message.topBid, writer.uint32(82).fork()).ldelim();
    }
    if (message.topAsk !== undefined) {
      OrderBook_OrderBookQuote.encode(message.topAsk, writer.uint32(98).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TopBidAsk {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTopBidAsk();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.security = Security.decode(reader, reader.uint32());
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.lastTradedTime = longToNumber(reader.int64() as Long);
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.lastTradedPrice = reader.int32();
          continue;
        case 7:
          if (tag !== 56) {
            break;
          }

          message.volumeTradedToday = reader.int32();
          continue;
        case 10:
          if (tag !== 82) {
            break;
          }

          message.topBid = OrderBook_OrderBookQuote.decode(reader, reader.uint32());
          continue;
        case 12:
          if (tag !== 98) {
            break;
          }

          message.topAsk = OrderBook_OrderBookQuote.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TopBidAsk {
    return {
      security: isSet(object.security) ? Security.fromJSON(object.security) : undefined,
      lastTradedTime: isSet(object.lastTradedTime) ? globalThis.Number(object.lastTradedTime) : 0,
      lastTradedPrice: isSet(object.lastTradedPrice) ? globalThis.Number(object.lastTradedPrice) : 0,
      volumeTradedToday: isSet(object.volumeTradedToday) ? globalThis.Number(object.volumeTradedToday) : 0,
      topBid: isSet(object.topBid) ? OrderBook_OrderBookQuote.fromJSON(object.topBid) : undefined,
      topAsk: isSet(object.topAsk) ? OrderBook_OrderBookQuote.fromJSON(object.topAsk) : undefined,
    };
  },

  toJSON(message: TopBidAsk): unknown {
    const obj: any = {};
    if (message.security !== undefined) {
      obj.security = Security.toJSON(message.security);
    }
    if (message.lastTradedTime !== 0) {
      obj.lastTradedTime = Math.round(message.lastTradedTime);
    }
    if (message.lastTradedPrice !== 0) {
      obj.lastTradedPrice = Math.round(message.lastTradedPrice);
    }
    if (message.volumeTradedToday !== 0) {
      obj.volumeTradedToday = Math.round(message.volumeTradedToday);
    }
    if (message.topBid !== undefined) {
      obj.topBid = OrderBook_OrderBookQuote.toJSON(message.topBid);
    }
    if (message.topAsk !== undefined) {
      obj.topAsk = OrderBook_OrderBookQuote.toJSON(message.topAsk);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TopBidAsk>, I>>(base?: I): TopBidAsk {
    return TopBidAsk.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TopBidAsk>, I>>(object: I): TopBidAsk {
    const message = createBaseTopBidAsk();
    message.security = (object.security !== undefined && object.security !== null)
      ? Security.fromPartial(object.security)
      : undefined;
    message.lastTradedTime = object.lastTradedTime ?? 0;
    message.lastTradedPrice = object.lastTradedPrice ?? 0;
    message.volumeTradedToday = object.volumeTradedToday ?? 0;
    message.topBid = (object.topBid !== undefined && object.topBid !== null)
      ? OrderBook_OrderBookQuote.fromPartial(object.topBid)
      : undefined;
    message.topAsk = (object.topAsk !== undefined && object.topAsk !== null)
      ? OrderBook_OrderBookQuote.fromPartial(object.topAsk)
      : undefined;
    return message;
  },
};

function createBaseGetSeriesRequest(): GetSeriesRequest {
  return { seriesName: "", security: undefined, timeBucket: undefined, startTime: 0, endTime: 0, parameters: [] };
}

export const GetSeriesRequest = {
  encode(message: GetSeriesRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.seriesName !== "") {
      writer.uint32(18).string(message.seriesName);
    }
    if (message.security !== undefined) {
      Security.encode(message.security, writer.uint32(34).fork()).ldelim();
    }
    if (message.timeBucket !== undefined) {
      TimeBucket.encode(message.timeBucket, writer.uint32(50).fork()).ldelim();
    }
    if (message.startTime !== 0) {
      writer.uint32(64).int64(message.startTime);
    }
    if (message.endTime !== 0) {
      writer.uint32(80).int64(message.endTime);
    }
    for (const v of message.parameters) {
      Params.encode(v!, writer.uint32(98).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetSeriesRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetSeriesRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2:
          if (tag !== 18) {
            break;
          }

          message.seriesName = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.security = Security.decode(reader, reader.uint32());
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.timeBucket = TimeBucket.decode(reader, reader.uint32());
          continue;
        case 8:
          if (tag !== 64) {
            break;
          }

          message.startTime = longToNumber(reader.int64() as Long);
          continue;
        case 10:
          if (tag !== 80) {
            break;
          }

          message.endTime = longToNumber(reader.int64() as Long);
          continue;
        case 12:
          if (tag !== 98) {
            break;
          }

          message.parameters.push(Params.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetSeriesRequest {
    return {
      seriesName: isSet(object.seriesName) ? globalThis.String(object.seriesName) : "",
      security: isSet(object.security) ? Security.fromJSON(object.security) : undefined,
      timeBucket: isSet(object.timeBucket) ? TimeBucket.fromJSON(object.timeBucket) : undefined,
      startTime: isSet(object.startTime) ? globalThis.Number(object.startTime) : 0,
      endTime: isSet(object.endTime) ? globalThis.Number(object.endTime) : 0,
      parameters: globalThis.Array.isArray(object?.parameters)
        ? object.parameters.map((e: any) => Params.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GetSeriesRequest): unknown {
    const obj: any = {};
    if (message.seriesName !== "") {
      obj.seriesName = message.seriesName;
    }
    if (message.security !== undefined) {
      obj.security = Security.toJSON(message.security);
    }
    if (message.timeBucket !== undefined) {
      obj.timeBucket = TimeBucket.toJSON(message.timeBucket);
    }
    if (message.startTime !== 0) {
      obj.startTime = Math.round(message.startTime);
    }
    if (message.endTime !== 0) {
      obj.endTime = Math.round(message.endTime);
    }
    if (message.parameters?.length) {
      obj.parameters = message.parameters.map((e) => Params.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetSeriesRequest>, I>>(base?: I): GetSeriesRequest {
    return GetSeriesRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetSeriesRequest>, I>>(object: I): GetSeriesRequest {
    const message = createBaseGetSeriesRequest();
    message.seriesName = object.seriesName ?? "";
    message.security = (object.security !== undefined && object.security !== null)
      ? Security.fromPartial(object.security)
      : undefined;
    message.timeBucket = (object.timeBucket !== undefined && object.timeBucket !== null)
      ? TimeBucket.fromPartial(object.timeBucket)
      : undefined;
    message.startTime = object.startTime ?? 0;
    message.endTime = object.endTime ?? 0;
    message.parameters = object.parameters?.map((e) => Params.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetSeriesResponse(): GetSeriesResponse {
  return { series: [] };
}

export const GetSeriesResponse = {
  encode(message: GetSeriesResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.series) {
      GetSeriesResponse_Series.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetSeriesResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetSeriesResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.series.push(GetSeriesResponse_Series.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetSeriesResponse {
    return {
      series: globalThis.Array.isArray(object?.series)
        ? object.series.map((e: any) => GetSeriesResponse_Series.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GetSeriesResponse): unknown {
    const obj: any = {};
    if (message.series?.length) {
      obj.series = message.series.map((e) => GetSeriesResponse_Series.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetSeriesResponse>, I>>(base?: I): GetSeriesResponse {
    return GetSeriesResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetSeriesResponse>, I>>(object: I): GetSeriesResponse {
    const message = createBaseGetSeriesResponse();
    message.series = object.series?.map((e) => GetSeriesResponse_Series.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetSeriesResponse_DataPoint(): GetSeriesResponse_DataPoint {
  return { timestamp: 0, label: "", values: [] };
}

export const GetSeriesResponse_DataPoint = {
  encode(message: GetSeriesResponse_DataPoint, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.timestamp !== 0) {
      writer.uint32(8).int64(message.timestamp);
    }
    if (message.label !== "") {
      writer.uint32(18).string(message.label);
    }
    writer.uint32(34).fork();
    for (const v of message.values) {
      writer.double(v);
    }
    writer.ldelim();
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetSeriesResponse_DataPoint {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetSeriesResponse_DataPoint();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.timestamp = longToNumber(reader.int64() as Long);
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.label = reader.string();
          continue;
        case 4:
          if (tag === 33) {
            message.values.push(reader.double());

            continue;
          }

          if (tag === 34) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.values.push(reader.double());
            }

            continue;
          }

          break;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetSeriesResponse_DataPoint {
    return {
      timestamp: isSet(object.timestamp) ? globalThis.Number(object.timestamp) : 0,
      label: isSet(object.label) ? globalThis.String(object.label) : "",
      values: globalThis.Array.isArray(object?.values) ? object.values.map((e: any) => globalThis.Number(e)) : [],
    };
  },

  toJSON(message: GetSeriesResponse_DataPoint): unknown {
    const obj: any = {};
    if (message.timestamp !== 0) {
      obj.timestamp = Math.round(message.timestamp);
    }
    if (message.label !== "") {
      obj.label = message.label;
    }
    if (message.values?.length) {
      obj.values = message.values;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetSeriesResponse_DataPoint>, I>>(base?: I): GetSeriesResponse_DataPoint {
    return GetSeriesResponse_DataPoint.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetSeriesResponse_DataPoint>, I>>(object: I): GetSeriesResponse_DataPoint {
    const message = createBaseGetSeriesResponse_DataPoint();
    message.timestamp = object.timestamp ?? 0;
    message.label = object.label ?? "";
    message.values = object.values?.map((e) => e) || [];
    return message;
  },
};

function createBaseGetSeriesResponse_Series(): GetSeriesResponse_Series {
  return { seriesName: "", keys: [], dataPoints: [], firstDatapointTime: "", lastDatapointTime: "" };
}

export const GetSeriesResponse_Series = {
  encode(message: GetSeriesResponse_Series, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.seriesName !== "") {
      writer.uint32(10).string(message.seriesName);
    }
    for (const v of message.keys) {
      writer.uint32(18).string(v!);
    }
    for (const v of message.dataPoints) {
      GetSeriesResponse_DataPoint.encode(v!, writer.uint32(34).fork()).ldelim();
    }
    if (message.firstDatapointTime !== "") {
      writer.uint32(50).string(message.firstDatapointTime);
    }
    if (message.lastDatapointTime !== "") {
      writer.uint32(66).string(message.lastDatapointTime);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetSeriesResponse_Series {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetSeriesResponse_Series();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.seriesName = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.keys.push(reader.string());
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.dataPoints.push(GetSeriesResponse_DataPoint.decode(reader, reader.uint32()));
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.firstDatapointTime = reader.string();
          continue;
        case 8:
          if (tag !== 66) {
            break;
          }

          message.lastDatapointTime = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetSeriesResponse_Series {
    return {
      seriesName: isSet(object.seriesName) ? globalThis.String(object.seriesName) : "",
      keys: globalThis.Array.isArray(object?.keys) ? object.keys.map((e: any) => globalThis.String(e)) : [],
      dataPoints: globalThis.Array.isArray(object?.dataPoints)
        ? object.dataPoints.map((e: any) => GetSeriesResponse_DataPoint.fromJSON(e))
        : [],
      firstDatapointTime: isSet(object.firstDatapointTime) ? globalThis.String(object.firstDatapointTime) : "",
      lastDatapointTime: isSet(object.lastDatapointTime) ? globalThis.String(object.lastDatapointTime) : "",
    };
  },

  toJSON(message: GetSeriesResponse_Series): unknown {
    const obj: any = {};
    if (message.seriesName !== "") {
      obj.seriesName = message.seriesName;
    }
    if (message.keys?.length) {
      obj.keys = message.keys;
    }
    if (message.dataPoints?.length) {
      obj.dataPoints = message.dataPoints.map((e) => GetSeriesResponse_DataPoint.toJSON(e));
    }
    if (message.firstDatapointTime !== "") {
      obj.firstDatapointTime = message.firstDatapointTime;
    }
    if (message.lastDatapointTime !== "") {
      obj.lastDatapointTime = message.lastDatapointTime;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetSeriesResponse_Series>, I>>(base?: I): GetSeriesResponse_Series {
    return GetSeriesResponse_Series.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetSeriesResponse_Series>, I>>(object: I): GetSeriesResponse_Series {
    const message = createBaseGetSeriesResponse_Series();
    message.seriesName = object.seriesName ?? "";
    message.keys = object.keys?.map((e) => e) || [];
    message.dataPoints = object.dataPoints?.map((e) => GetSeriesResponse_DataPoint.fromPartial(e)) || [];
    message.firstDatapointTime = object.firstDatapointTime ?? "";
    message.lastDatapointTime = object.lastDatapointTime ?? "";
    return message;
  },
};

function createBaseGetCurrentOpenInterestRequest(): GetCurrentOpenInterestRequest {
  return { security: undefined, timeBucket: undefined };
}

export const GetCurrentOpenInterestRequest = {
  encode(message: GetCurrentOpenInterestRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.security !== undefined) {
      Security.encode(message.security, writer.uint32(10).fork()).ldelim();
    }
    if (message.timeBucket !== undefined) {
      TimeBucket.encode(message.timeBucket, writer.uint32(26).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetCurrentOpenInterestRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetCurrentOpenInterestRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.security = Security.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.timeBucket = TimeBucket.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetCurrentOpenInterestRequest {
    return {
      security: isSet(object.security) ? Security.fromJSON(object.security) : undefined,
      timeBucket: isSet(object.timeBucket) ? TimeBucket.fromJSON(object.timeBucket) : undefined,
    };
  },

  toJSON(message: GetCurrentOpenInterestRequest): unknown {
    const obj: any = {};
    if (message.security !== undefined) {
      obj.security = Security.toJSON(message.security);
    }
    if (message.timeBucket !== undefined) {
      obj.timeBucket = TimeBucket.toJSON(message.timeBucket);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetCurrentOpenInterestRequest>, I>>(base?: I): GetCurrentOpenInterestRequest {
    return GetCurrentOpenInterestRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetCurrentOpenInterestRequest>, I>>(
    object: I,
  ): GetCurrentOpenInterestRequest {
    const message = createBaseGetCurrentOpenInterestRequest();
    message.security = (object.security !== undefined && object.security !== null)
      ? Security.fromPartial(object.security)
      : undefined;
    message.timeBucket = (object.timeBucket !== undefined && object.timeBucket !== null)
      ? TimeBucket.fromPartial(object.timeBucket)
      : undefined;
    return message;
  },
};

function createBaseGetCurrentOpenInterestResponse(): GetCurrentOpenInterestResponse {
  return { security: undefined, expiryOpenInterests: [] };
}

export const GetCurrentOpenInterestResponse = {
  encode(message: GetCurrentOpenInterestResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.security !== undefined) {
      Security.encode(message.security, writer.uint32(18).fork()).ldelim();
    }
    for (const v of message.expiryOpenInterests) {
      GetCurrentOpenInterestResponse_ExpiryOpenInterest.encode(v!, writer.uint32(34).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetCurrentOpenInterestResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetCurrentOpenInterestResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2:
          if (tag !== 18) {
            break;
          }

          message.security = Security.decode(reader, reader.uint32());
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.expiryOpenInterests.push(
            GetCurrentOpenInterestResponse_ExpiryOpenInterest.decode(reader, reader.uint32()),
          );
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetCurrentOpenInterestResponse {
    return {
      security: isSet(object.security) ? Security.fromJSON(object.security) : undefined,
      expiryOpenInterests: globalThis.Array.isArray(object?.expiryOpenInterests)
        ? object.expiryOpenInterests.map((e: any) => GetCurrentOpenInterestResponse_ExpiryOpenInterest.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GetCurrentOpenInterestResponse): unknown {
    const obj: any = {};
    if (message.security !== undefined) {
      obj.security = Security.toJSON(message.security);
    }
    if (message.expiryOpenInterests?.length) {
      obj.expiryOpenInterests = message.expiryOpenInterests.map((e) =>
        GetCurrentOpenInterestResponse_ExpiryOpenInterest.toJSON(e)
      );
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetCurrentOpenInterestResponse>, I>>(base?: I): GetCurrentOpenInterestResponse {
    return GetCurrentOpenInterestResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetCurrentOpenInterestResponse>, I>>(
    object: I,
  ): GetCurrentOpenInterestResponse {
    const message = createBaseGetCurrentOpenInterestResponse();
    message.security = (object.security !== undefined && object.security !== null)
      ? Security.fromPartial(object.security)
      : undefined;
    message.expiryOpenInterests =
      object.expiryOpenInterests?.map((e) => GetCurrentOpenInterestResponse_ExpiryOpenInterest.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetCurrentOpenInterestResponse_ExpiryOpenInterest(): GetCurrentOpenInterestResponse_ExpiryOpenInterest {
  return { expiry: undefined, strikeOpenInterests: [] };
}

export const GetCurrentOpenInterestResponse_ExpiryOpenInterest = {
  encode(
    message: GetCurrentOpenInterestResponse_ExpiryOpenInterest,
    writer: _m0.Writer = _m0.Writer.create(),
  ): _m0.Writer {
    if (message.expiry !== undefined) {
      Expiry.encode(message.expiry, writer.uint32(18).fork()).ldelim();
    }
    for (const v of message.strikeOpenInterests) {
      GetCurrentOpenInterestResponse_ExpiryOpenInterest_StrikeOpenInterest.encode(v!, writer.uint32(34).fork())
        .ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetCurrentOpenInterestResponse_ExpiryOpenInterest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetCurrentOpenInterestResponse_ExpiryOpenInterest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2:
          if (tag !== 18) {
            break;
          }

          message.expiry = Expiry.decode(reader, reader.uint32());
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.strikeOpenInterests.push(
            GetCurrentOpenInterestResponse_ExpiryOpenInterest_StrikeOpenInterest.decode(reader, reader.uint32()),
          );
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetCurrentOpenInterestResponse_ExpiryOpenInterest {
    return {
      expiry: isSet(object.expiry) ? Expiry.fromJSON(object.expiry) : undefined,
      strikeOpenInterests: globalThis.Array.isArray(object?.strikeOpenInterests)
        ? object.strikeOpenInterests.map((e: any) =>
          GetCurrentOpenInterestResponse_ExpiryOpenInterest_StrikeOpenInterest.fromJSON(e)
        )
        : [],
    };
  },

  toJSON(message: GetCurrentOpenInterestResponse_ExpiryOpenInterest): unknown {
    const obj: any = {};
    if (message.expiry !== undefined) {
      obj.expiry = Expiry.toJSON(message.expiry);
    }
    if (message.strikeOpenInterests?.length) {
      obj.strikeOpenInterests = message.strikeOpenInterests.map((e) =>
        GetCurrentOpenInterestResponse_ExpiryOpenInterest_StrikeOpenInterest.toJSON(e)
      );
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetCurrentOpenInterestResponse_ExpiryOpenInterest>, I>>(
    base?: I,
  ): GetCurrentOpenInterestResponse_ExpiryOpenInterest {
    return GetCurrentOpenInterestResponse_ExpiryOpenInterest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetCurrentOpenInterestResponse_ExpiryOpenInterest>, I>>(
    object: I,
  ): GetCurrentOpenInterestResponse_ExpiryOpenInterest {
    const message = createBaseGetCurrentOpenInterestResponse_ExpiryOpenInterest();
    message.expiry = (object.expiry !== undefined && object.expiry !== null)
      ? Expiry.fromPartial(object.expiry)
      : undefined;
    message.strikeOpenInterests =
      object.strikeOpenInterests?.map((e) =>
        GetCurrentOpenInterestResponse_ExpiryOpenInterest_StrikeOpenInterest.fromPartial(e)
      ) || [];
    return message;
  },
};

function createBaseGetCurrentOpenInterestResponse_ExpiryOpenInterest_StrikeOpenInterest(): GetCurrentOpenInterestResponse_ExpiryOpenInterest_StrikeOpenInterest {
  return { strike: 0, callOi: 0, putOi: 0, previousCallOi: 0, previousPutOi: 0 };
}

export const GetCurrentOpenInterestResponse_ExpiryOpenInterest_StrikeOpenInterest = {
  encode(
    message: GetCurrentOpenInterestResponse_ExpiryOpenInterest_StrikeOpenInterest,
    writer: _m0.Writer = _m0.Writer.create(),
  ): _m0.Writer {
    if (message.strike !== 0) {
      writer.uint32(16).int32(message.strike);
    }
    if (message.callOi !== 0) {
      writer.uint32(32).int32(message.callOi);
    }
    if (message.putOi !== 0) {
      writer.uint32(48).int32(message.putOi);
    }
    if (message.previousCallOi !== 0) {
      writer.uint32(64).int32(message.previousCallOi);
    }
    if (message.previousPutOi !== 0) {
      writer.uint32(80).int32(message.previousPutOi);
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number,
  ): GetCurrentOpenInterestResponse_ExpiryOpenInterest_StrikeOpenInterest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetCurrentOpenInterestResponse_ExpiryOpenInterest_StrikeOpenInterest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2:
          if (tag !== 16) {
            break;
          }

          message.strike = reader.int32();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.callOi = reader.int32();
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.putOi = reader.int32();
          continue;
        case 8:
          if (tag !== 64) {
            break;
          }

          message.previousCallOi = reader.int32();
          continue;
        case 10:
          if (tag !== 80) {
            break;
          }

          message.previousPutOi = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetCurrentOpenInterestResponse_ExpiryOpenInterest_StrikeOpenInterest {
    return {
      strike: isSet(object.strike) ? globalThis.Number(object.strike) : 0,
      callOi: isSet(object.callOi) ? globalThis.Number(object.callOi) : 0,
      putOi: isSet(object.putOi) ? globalThis.Number(object.putOi) : 0,
      previousCallOi: isSet(object.previousCallOi) ? globalThis.Number(object.previousCallOi) : 0,
      previousPutOi: isSet(object.previousPutOi) ? globalThis.Number(object.previousPutOi) : 0,
    };
  },

  toJSON(message: GetCurrentOpenInterestResponse_ExpiryOpenInterest_StrikeOpenInterest): unknown {
    const obj: any = {};
    if (message.strike !== 0) {
      obj.strike = Math.round(message.strike);
    }
    if (message.callOi !== 0) {
      obj.callOi = Math.round(message.callOi);
    }
    if (message.putOi !== 0) {
      obj.putOi = Math.round(message.putOi);
    }
    if (message.previousCallOi !== 0) {
      obj.previousCallOi = Math.round(message.previousCallOi);
    }
    if (message.previousPutOi !== 0) {
      obj.previousPutOi = Math.round(message.previousPutOi);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetCurrentOpenInterestResponse_ExpiryOpenInterest_StrikeOpenInterest>, I>>(
    base?: I,
  ): GetCurrentOpenInterestResponse_ExpiryOpenInterest_StrikeOpenInterest {
    return GetCurrentOpenInterestResponse_ExpiryOpenInterest_StrikeOpenInterest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetCurrentOpenInterestResponse_ExpiryOpenInterest_StrikeOpenInterest>, I>>(
    object: I,
  ): GetCurrentOpenInterestResponse_ExpiryOpenInterest_StrikeOpenInterest {
    const message = createBaseGetCurrentOpenInterestResponse_ExpiryOpenInterest_StrikeOpenInterest();
    message.strike = object.strike ?? 0;
    message.callOi = object.callOi ?? 0;
    message.putOi = object.putOi ?? 0;
    message.previousCallOi = object.previousCallOi ?? 0;
    message.previousPutOi = object.previousPutOi ?? 0;
    return message;
  },
};

function createBaseGetTradedSecuritiesRequest(): GetTradedSecuritiesRequest {
  return { start: 0, end: 0, segment: 0, exchange: 0 };
}

export const GetTradedSecuritiesRequest = {
  encode(message: GetTradedSecuritiesRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.start !== 0) {
      writer.uint32(8).int64(message.start);
    }
    if (message.end !== 0) {
      writer.uint32(16).int64(message.end);
    }
    if (message.segment !== 0) {
      writer.uint32(24).int32(message.segment);
    }
    if (message.exchange !== 0) {
      writer.uint32(32).int32(message.exchange);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetTradedSecuritiesRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetTradedSecuritiesRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.start = longToNumber(reader.int64() as Long);
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.end = longToNumber(reader.int64() as Long);
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.segment = reader.int32() as any;
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.exchange = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetTradedSecuritiesRequest {
    return {
      start: isSet(object.start) ? globalThis.Number(object.start) : 0,
      end: isSet(object.end) ? globalThis.Number(object.end) : 0,
      segment: isSet(object.segment) ? segmentFromJSON(object.segment) : 0,
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
    };
  },

  toJSON(message: GetTradedSecuritiesRequest): unknown {
    const obj: any = {};
    if (message.start !== 0) {
      obj.start = Math.round(message.start);
    }
    if (message.end !== 0) {
      obj.end = Math.round(message.end);
    }
    if (message.segment !== 0) {
      obj.segment = segmentToJSON(message.segment);
    }
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetTradedSecuritiesRequest>, I>>(base?: I): GetTradedSecuritiesRequest {
    return GetTradedSecuritiesRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetTradedSecuritiesRequest>, I>>(object: I): GetTradedSecuritiesRequest {
    const message = createBaseGetTradedSecuritiesRequest();
    message.start = object.start ?? 0;
    message.end = object.end ?? 0;
    message.segment = object.segment ?? 0;
    message.exchange = object.exchange ?? 0;
    return message;
  },
};

function createBaseGetTradedSecuritiesResponse(): GetTradedSecuritiesResponse {
  return { securities: [] };
}

export const GetTradedSecuritiesResponse = {
  encode(message: GetTradedSecuritiesResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.securities) {
      Security1.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetTradedSecuritiesResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetTradedSecuritiesResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.securities.push(Security1.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetTradedSecuritiesResponse {
    return {
      securities: globalThis.Array.isArray(object?.securities)
        ? object.securities.map((e: any) => Security1.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GetTradedSecuritiesResponse): unknown {
    const obj: any = {};
    if (message.securities?.length) {
      obj.securities = message.securities.map((e) => Security1.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetTradedSecuritiesResponse>, I>>(base?: I): GetTradedSecuritiesResponse {
    return GetTradedSecuritiesResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetTradedSecuritiesResponse>, I>>(object: I): GetTradedSecuritiesResponse {
    const message = createBaseGetTradedSecuritiesResponse();
    message.securities = object.securities?.map((e) => Security1.fromPartial(e)) || [];
    return message;
  },
};

export interface CandleService {
  GetCandlesBulkV2(request: GetCandlesBulkRequestV2): Promise<GetCandlesBulkResponseV2>;
  GetCandlesV2(request: GetCandlesRequestV2): Promise<GetCandlesResponseV2>;
  GetInMemoryCandlesBulk(request: GetCandlesBulkRequestV2): Promise<GetCandlesBulkResponseV2>;
  GetTradedSecurities(request: GetTradedSecuritiesRequest): Promise<GetTradedSecuritiesResponse>;
}

export const CandleServiceServiceName = "com.tick2trade.api.candledatadepot.CandleService";
export class CandleServiceClientImpl implements CandleService {
  private readonly rpc: Rpc;
  private readonly service: string;
  constructor(rpc: Rpc, opts?: { service?: string }) {
    this.service = opts?.service || CandleServiceServiceName;
    this.rpc = rpc;
    this.GetCandlesBulkV2 = this.GetCandlesBulkV2.bind(this);
    this.GetCandlesV2 = this.GetCandlesV2.bind(this);
    this.GetInMemoryCandlesBulk = this.GetInMemoryCandlesBulk.bind(this);
    this.GetTradedSecurities = this.GetTradedSecurities.bind(this);
  }
  GetCandlesBulkV2(request: GetCandlesBulkRequestV2): Promise<GetCandlesBulkResponseV2> {
    const data = GetCandlesBulkRequestV2.encode(request).finish();
    const promise = this.rpc.request(this.service, "GetCandlesBulkV2", data);
    return promise.then((data) => GetCandlesBulkResponseV2.decode(_m0.Reader.create(data)));
  }

  GetCandlesV2(request: GetCandlesRequestV2): Promise<GetCandlesResponseV2> {
    const data = GetCandlesRequestV2.encode(request).finish();
    const promise = this.rpc.request(this.service, "GetCandlesV2", data);
    return promise.then((data) => GetCandlesResponseV2.decode(_m0.Reader.create(data)));
  }

  GetInMemoryCandlesBulk(request: GetCandlesBulkRequestV2): Promise<GetCandlesBulkResponseV2> {
    const data = GetCandlesBulkRequestV2.encode(request).finish();
    const promise = this.rpc.request(this.service, "GetInMemoryCandlesBulk", data);
    return promise.then((data) => GetCandlesBulkResponseV2.decode(_m0.Reader.create(data)));
  }

  GetTradedSecurities(request: GetTradedSecuritiesRequest): Promise<GetTradedSecuritiesResponse> {
    const data = GetTradedSecuritiesRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "GetTradedSecurities", data);
    return promise.then((data) => GetTradedSecuritiesResponse.decode(_m0.Reader.create(data)));
  }
}

export interface OpenInterestService {
  GetCurrentOpenInterest(request: GetCurrentOpenInterestRequest): Promise<GetCurrentOpenInterestResponse>;
  GetOpenInterestChange(request: OpenInterestChangeRequest): Promise<OpenInterestChangeResponse>;
}

export const OpenInterestServiceServiceName = "com.tick2trade.api.candledatadepot.OpenInterestService";
export class OpenInterestServiceClientImpl implements OpenInterestService {
  private readonly rpc: Rpc;
  private readonly service: string;
  constructor(rpc: Rpc, opts?: { service?: string }) {
    this.service = opts?.service || OpenInterestServiceServiceName;
    this.rpc = rpc;
    this.GetCurrentOpenInterest = this.GetCurrentOpenInterest.bind(this);
    this.GetOpenInterestChange = this.GetOpenInterestChange.bind(this);
  }
  GetCurrentOpenInterest(request: GetCurrentOpenInterestRequest): Promise<GetCurrentOpenInterestResponse> {
    const data = GetCurrentOpenInterestRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "GetCurrentOpenInterest", data);
    return promise.then((data) => GetCurrentOpenInterestResponse.decode(_m0.Reader.create(data)));
  }

  GetOpenInterestChange(request: OpenInterestChangeRequest): Promise<OpenInterestChangeResponse> {
    const data = OpenInterestChangeRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "GetOpenInterestChange", data);
    return promise.then((data) => OpenInterestChangeResponse.decode(_m0.Reader.create(data)));
  }
}

export interface SeriesService {
  GetSeries(request: GetSeriesRequest): Promise<GetSeriesResponse>;
}

export const SeriesServiceServiceName = "com.tick2trade.api.candledatadepot.SeriesService";
export class SeriesServiceClientImpl implements SeriesService {
  private readonly rpc: Rpc;
  private readonly service: string;
  constructor(rpc: Rpc, opts?: { service?: string }) {
    this.service = opts?.service || SeriesServiceServiceName;
    this.rpc = rpc;
    this.GetSeries = this.GetSeries.bind(this);
  }
  GetSeries(request: GetSeriesRequest): Promise<GetSeriesResponse> {
    const data = GetSeriesRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "GetSeries", data);
    return promise.then((data) => GetSeriesResponse.decode(_m0.Reader.create(data)));
  }
}

interface Rpc {
  request(service: string, method: string, data: Uint8Array): Promise<Uint8Array>;
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (long.lt(globalThis.Number.MIN_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
